export enum LayoutFavoriteFilterModeEnum
{
  showAll = 0,
  showFavorites = 1,
}
